module.exports = __webpack_public_path__ + "static/img/indexImg1.412ce27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexImg1.jpg
// module id = gM+r
// module chunks = 3